import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { UserInfo } from '../user/user-management/models/user.model';

@Injectable({
  providedIn: 'root'
})

export class NavigationService {

  baseMenu: MenuItem[] = [
    {key: 'main', title: '메인', url: '/main', iconName: 'dashboard', order: 1},
  ];

  permissionMenu: MenuItem[] = [
    {key: 'user', title: '사용자', url: '/user', iconName: 'person', order: 2},
    // 최상위 "출입관리". 예전에는 이 엔트리가 없어서 대메뉴 가드가 하위의
    // access-history 권한을 대신 보고 있었고, 그래서 출입권한만 부여받은 계정은
    // 대메뉴가 통째로 사라져 출입권한 화면에 들어갈 방법이 없었다.
    {key: 'access', title: '출입관리', url: '/access', iconName: 'lock_open', order: 3},
    {key: 'access-history', title: '출입이력', url: '/access/history', iconName: 'history', order: 31},
    {key: 'visit', title: '방문증관리', url: '/visit', iconName: 'badge', order: 5},
    {key: 'access-permission', title: '권한', url: '/access/permission', svgIconName: 'add_moderator', order: 7},
    {key: 'device', title: '장치', url: '/device', iconName: 'stay_primary_landscape', order: 8},
    {key: 'admin', title: '관리자', url: '/admin', iconName: 'admin_panel_settings', order: 9},
  ];

  /**
   * 메가메뉴·사이드 서브네비의 서브링크 권한 엔트리.
   *
   * 최상위(permissionMenu)와 분리한 이유: 이 배열은 오직 showMenu(url) 조회용이라
   * title/icon 이 없다. 최상위와 한 배열에 섞으면 나중에 메뉴를 순회해 그리는 코드가
   * 생겼을 때 제목 없는 항목이 화면에 새어나간다.
   *
   * key 는 permission_menu_catalog.menu_key 와 정확히 일치해야 한다 — 서버가 내려주는
   * menuPermissions 가 그 값이기 때문이다. url 은 네비게이션 템플릿의 goToLink 경로.
   *
   * access-history / access-permission / device 는 서브링크 URL 이 최상위와 같아
   * permissionMenu 에 이미 있으므로 여기 중복해서 넣지 않는다.
   */
  subPermissionMenu: MenuItem[] = [
    {key: 'user.organization',     url: '/user/organization',    order: 21},
    {key: 'user.management',       url: '/user/management',      order: 22},
    {key: 'visit.info',            url: '/visit/visit-info',     order: 51},
    {key: 'visit.entrance',        url: '/visit/visit-entrance', order: 52},
    {key: 'admin.settings',        url: '/admin/settings',       order: 91},
    {key: 'admin.management',      url: '/admin/management',     order: 92},
    {key: 'admin.key-management',  url: '/admin/key-management', order: 93},
    {key: 'admin.system-log',      url: '/admin/system-log',     order: 94},
  ];

  masterMenu: MenuItem[] = this.baseMenu.concat(this.permissionMenu).concat(this.subPermissionMenu);

  logoutMenuItem: MenuItem = {title: '로그아웃', url: '/signin', svgIconName: 'logout', order: 10};

  menu!: MenuItem[];

  sideNav: MatSidenav | undefined;

  userInfo?: UserInfo;

  currentUrl?: string;
  constructor(
    private location: Location,
  ) { 
    this.init();
  }

  init() {
    this.masterMenu = this.masterMenu.sort((a, b) => a.order - b.order);
    this.location.onUrlChange((url: string, state: any) => {
      this.currentUrl = url;
      this.sideNav?.close();
    });
  }

  setUserInfo(userInfo: UserInfo) {
    this.userInfo = userInfo;
    this.setMenuType(userInfo.accountTypeCode)
  }

  setMenuType(accountType?: string) {
    switch(accountType) {
      case 'USER100130133': {
        this.menu = this.masterMenu;
        break;
      }
      case 'USER100130132': {
        const allowedMenus = this.userInfo?.menuPermissions ?? [];
        const allowed = (item: MenuItem) => !!item.key && allowedMenus.includes(item.key);
        this.menu = this.baseMenu
            .concat(this.permissionMenu.filter(allowed))
            .concat(this.subPermissionMenu.filter(allowed));
        break;
      }
      default: {
        this.menu = this.baseMenu;
      }
    }
  }

  setSideNav(sideNav: MatSidenav | undefined) {
    this.sideNav = sideNav;
  }

  toggle() {
    this.sideNav?.toggle();

  }

  back() {
    this.location.back();
  }
}

export interface MenuItem {
  key?: string,
  title?: string,
  url: string,
  iconName?: string,
  svgIconName?: string,
  onlyMaster?: boolean,
  order: number
}
